module.exports = __webpack_public_path__ + "assets/img/footer_banner_hpcr.96c24967.jpg";